import React, { useLayoutEffect, useState } from "react";
import { Layout, Card, Table, Input, Space, Button, Popconfirm } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { getAPI, postAPI, displayMessage } from "../../utils/common";
import {
  ALL_SUBSCRIPTION_PLAN,
  DELETE_SUBSCRIPTION_PLAN,
} from "../../constants/api";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { useNavigate } from "react-router-dom";

function SubscriptionPlanTable() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getList = () => {
    setLoading(true);
    getAPI(
      ALL_SUBSCRIPTION_PLAN,
      (data) => {
        if (data.status === true) {
          const formattedData = data.data.map((row, index) => ({
            key: index,
            ID: index + 1,
            Name: row.plan_name,
            Capacity: `${row.plan_room_capacity_start} to ${row.plan_room_capacity_end}`,
            Month_Price: row.plan_monthly_price,
            Year_Price: row.plan_yearly_price,
            Action: (
              <Space>
                <Button
                  onClick={() =>
                    navigate("/master/subscription-plan/edit/" + row.id)
                  }
                >
                  Edit
                </Button>
                <Popconfirm
                  title="Delete the plan"
                  description="Are you sure to delete this plan?"
                  onConfirm={() => deleteData(row.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button danger>Delete</Button>
                </Popconfirm>
              </Space>
            ),
          }));
          setState(formattedData);
          setFilteredState(formattedData);
          setLoading(false);
        } else {
          setState([]);
          setFilteredState([]);
          setLoading(false);
        }
      },
      () => {
        setState([]);
        setFilteredState([]);
        setLoading(false);
      }
    );
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter((data) =>
      data.Name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredState(filtered);
  };

  const deleteData = (id) => {
    setLoading(true);
    postAPI(
      DELETE_SUBSCRIPTION_PLAN,
      { id },
      (data) => {
        if (data.status === true) {
          displayMessage(SUCCESS_MESSAGE, data.message);
          getList();
        } else {
          displayMessage(ERROR_MSG_TYPE, data.message);
        }
        setLoading(false);
      },
      () => {
        displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
        setLoading(false);
      }
    );
  };

  const columns = [
    { title: "Sno", dataIndex: "ID", width: 50 },
    { title: "Name", dataIndex: "Name", width: 150 },
    { title: "Capacity", dataIndex: "Capacity", width: 150 },
    { title: "Month Price", dataIndex: "Month_Price", width: 100 },
    { title: "Year Price", dataIndex: "Year_Price", width: 100 },
    { title: "Action", dataIndex: "Action", width: 150 },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Manage Subscription Plans"
          extra={
            <Space>
              <Input
                placeholder="Search by Name"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 300 }}
              />
              <Button onClick={() => navigate("/master/subscription-plan/add")}>
                Add <PlusOutlined />
              </Button>
            </Space>
          }
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState}
            pagination={{ pageSize: 10 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default SubscriptionPlanTable;
